export const nextCashDraft = (draft, key) => {
  const current = String(draft || "0");
  if (key === "clear") return "0";
  if (key === "backspace") return current.slice(0, -1) || "0";
  const next = current === "0" && key !== "." ? key : current + key;
  return /^\d+(?:\.\d{0,2})?$/.test(next) ? next : current;
};
